export const iconFontAwesomeUsersPeopleUserMinus = (
	<i className="fa-solid fa-user-minus"></i>
);
